// index.js (or your main entry file)

import React from 'react';
import { BrowserRouter, Routes, Route, Outlet, Navigate } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import LoginHeaderLogo from './assets/images/login_header.png';
import {
    Auth,
    ConfigProvider,
    WebSocketProvider,
    Unauthorized,
    Email,
    EmailCampaign,
    EmailCampaignDetail,
    EmailTemplate,
    EmailTemplateDetail,
    EmailLog,
    EmailLogDetail,
    UserInit,
    ActivityTracker,
    NavbarLeft,
    NotFoundPage,
    TenantInvite,
    NavbarTop,
} from './m34n-ui/src/lib.js';
import Catalog from './Catalog';
import CatalogProductDetail from './Catalog/detail';
import NavbarLogo from './assets/images/login_header.png';
import Products from './Products';
import ProductDetail from './Products/detail';
import OrderGrid from './Order';
import OrderDetail from './Order/detail';
import OrderSuccess from './Order/success';
import Builder from './Builder';
import './index.css';

const AdminLayout = () => (
    <div style={{ display: 'flex', height: '100vh', width: '100vw' }}>
        {/* NavbarLeft is positioned outside the main flex container to manage its own layout */}
        <NavbarLeft
            NavbarLogo={NavbarLogo}
            menu={{
                options: [
                    {
                        name: 'Products',
                        url: 'products', // Removed leading '/'
                        icon: (
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25" />
                            </svg>
                        )
                    },
                    {
                        name: 'Orders',
                        url: 'orders', // Removed leading '/'
                        icon: (
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0 0 12 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75Z" />
                            </svg>
                        )
                    },
                    {
                        name: 'Email',
                        url: 'email', // Removed leading '/'
                        children: [
                            {
                                name: 'Campaigns',
                                url: 'email/campaigns',
                            },
                            {
                                name: 'Templates',
                                url: 'email/templates',
                            },
                            {
                                name: 'Logs',
                                url: 'email/logs',
                            }
                        ],
                        icon: (
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="m7.875 14.25 1.214 1.942a2.25 2.25 0 0 0 1.908 1.058h2.006c.776 0 1.497-.4 1.908-1.058l1.214-1.942M2.41 9h4.636a2.25 2.25 0 0 1 1.872 1.002l.164.246a2.25 2.25 0 0 0 1.872 1.002h2.092a2.25 2.25 0 0 0 1.872-1.002l.164-.246A2.25 2.25 0 0 1 16.954 9h4.636M2.41 9a2.25 2.25 0 0 0-.16.832V12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 12V9.832c0-.287-.055-.57-.16-.832M2.41 9a2.25 2.25 0 0 1 .382-.632l3.285-3.832a2.25 2.25 0 0 1 1.708-.786h8.43c.657 0 1.281.287 1.709.786l3.284 3.832c.163.19.291.404.382.632M4.5 20.25h15A2.25 2.25 0 0 0 21.75 18v-2.625c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125V18a2.25 2.25 0 0 0 2.25 2.25Z" />
                            </svg>
                        )
                    }
                ]
            }}
        />

        {/* Main Content Area */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <div style={{ height: '100px', width: '100%', position: 'sticky', top: 0, zIndex: 2 }}>
                <NavbarTop />
            </div>
            <div style={{ flex: 1, overflowY: 'auto', padding: '20px' }}>
                <Outlet />
            </div>
        </div>
        <ActivityTracker onLogout={() => { }} />
    </div>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <ConfigProvider>
            <BrowserRouter>
                <Routes>
                    {/* Public Routes */}
                    <Route path='/unauthorized' element={<Unauthorized />} />
                    <Route path='/' element={<Catalog />} />
                    <Route path='/catalog/product/:productId' element={<CatalogProductDetail />} />
                    <Route path='/order/:orderId/success' element={<OrderSuccess />} />

                    {/* Authentication Initialization */}
                    <Route path='/auth/init' element={<UserInit />} />

                    {/* Admin Routes */}
                    <Route path='/admin' element={
                        <Auth
                            LoginHeaderLogo={LoginHeaderLogo}
                            signInBlurb={`Sign in to your account`}
                        >
                            <WebSocketProvider>
                                <AdminLayout />
                            </WebSocketProvider>
                        </Auth>
                    }>
                        {/* Nested Admin Routes */}
                        <Route index element={<Navigate to="products" replace />} /> {/* Optional: Redirect /admin to a default admin page */}
                        
                        <Route path='email' element={<Email />} />
                        <Route path='email/templates' element={<EmailTemplate />} />
                        <Route path='email/template/:emailTemplateId' element={<EmailTemplateDetail />} />
                        <Route path='email/campaigns' element={<EmailCampaign />} />
                        <Route path='email/campaign/:campaignId' element={<EmailCampaignDetail />} />
                        <Route path='email/logs' element={<EmailLog />} />
                        <Route path='email/log/:logId' element={<EmailLogDetail />} />

                        <Route path='products' element={<Products />} />
                        <Route path='product/:productId' element={<ProductDetail />} />
                        <Route path='tenantInvite/:tenantId' element={<TenantInvite />} />

                        <Route path='orders' element={<OrderGrid />} />
                        <Route path='order/:orderId' element={<OrderDetail />} />

                        <Route path='*' element={<NotFoundPage />} />
                    </Route>

                    {/* Catch-All Route for Undefined Paths */}
                    <Route path='*' element={<NotFoundPage />} />
                </Routes>
            </BrowserRouter>
        </ConfigProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

